import { createContext, useContext } from "react";

export type ClientConfig = {
  backUrl: string;
};
export const FHConfigContext = createContext<ClientConfig>({
  backUrl: "https://back.feelinghome.es",
});

export const useFHConfig = () => {
  const config = useContext(FHConfigContext);
  if (!config)
    throw new Error(
      `Config not loaded, are you using FHConfigContext.Provider?`
    );
  return config;
};
